import { z } from "zod";

export const SiteSchema = z.object({
  city_name: z.string(),
  latitude: z.string(),
  longitude: z.string(),
});

export type Site = z.TypeOf<typeof SiteSchema>;
